import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';

@Component({
    selector: 'table-search',
    templateUrl: './table-search.component.html',
    standalone: false,
})
export class TableSearchComponent implements OnInit {
    @Input() model?: string | null;
    @Input() minSearchLength?: any;
    @Input() placeholderTxt?: string;
    @Input() containerClass?: string;
    @Input() theme?: string;

    @Output() getPage = new EventEmitter<any>();
    @Output() modelChange = new EventEmitter<string | null>();

    searchDelay: any = null;
    placeholderText: string = '';
    minSearchLengthValue: number = 3;
    themeValue: string = 'white';

    constructor (private translateService: TranslateService) {}

    ngOnInit () {
        this.placeholderText = this.placeholderTxt || this.translateService.getString('Search...');
        this.minSearchLengthValue = parseInt(this.minSearchLength || '3') || 3;
        this.themeValue = this.theme || 'white';
    }

    changeSearch () {
        if (this.searchDelay !== null) {
            clearTimeout(this.searchDelay);
        }

        this.searchDelay = setTimeout(() => {
            if ((this.model?.length || 0) >= this.minSearchLengthValue || (this.model?.length || 0) === 0) {
                this.getPage.emit(this.model || '');
            }
            this.searchDelay = null;
        }, 400);
    }

    onClearAction (event: Event) {
        this.model = '';
        this.modelChange.emit(this.model);
        this.getPage.emit('');

        const target = event.currentTarget as HTMLElement;
        const input = target.parentElement?.querySelector('input');
        if (input) {
            input.focus();
        }
    }

    showClearBtn (): boolean {
        return typeof this.model === 'string' && this.model.length > 0;
    }

    onModelChange () {
        this.modelChange.emit(this.model);

        if (this.model === '') {
            this.getPage.emit('');
            return;
        }
        this.changeSearch();
    }
}
